export const suggestions = {
  name: {
    title: 'Alternate names found',
    para:
      'Please consider one of the previous names you have used. <p>Using a consistent name helps us to process your case more quickly and eliminate potential misspellings.</p>',
    label: 'Suggested name',
    use: 'Use this name',
    dismiss: 'Use a different name instead',
  },
  address: {
    title: 'Alternate address found',
    para:
      'Please consider the highlighted change below.<p>Using the US Postal Service suggested address will help us process your case more quickly.</p>',
    label: 'Suggested address',
    use: 'Use this address',
    dismiss: 'Continue without USPS verification',
    alternate: 'Change address and try again',
    more: 'Add more information',
  },
  addressBook: {
    title: 'Select previous address',
    para: 'Choose the desired address from the list below.',
    label: 'Previous address',
    use: 'Use this address',
    dismiss: 'Close address book',
  },
};
